import { ActionReducer, combineReducers, MetaReducer } from '@ngrx/store';
import { reducer as declinedReasonsReducer } from './declined-reasons/declined-reasons.reducer';
import { LabourOperationsAction } from './labour-operations.actions';
import { labourOperationsInitialState } from './labour-operations.init';
import { LabourOperationsState } from './labour-operations.interfaces';
// eslint-disable-next-line max-len
import { ServiceGroupRatesState } from './service-group-rates/service-group-rate.interfaces';
import {
  reducer as rateReducer,
  serviceGroupRateStateHydration
} from './service-group-rates/service-group-rate.reducer';
import { ServiceGroupsState } from './service-groups/service-groups.interfaces';
import { reducer as serviceGroupReducer, serviceGroupStateHydration } from './service-groups/service-groups.reducer';
import { ServicesState } from './services/services.interfaces';
import { reducer as servicesReducer, servicesStateHydration } from './services/services.reducer';
export function labourOperationsReducer(
  state: LabourOperationsState,
  action: LabourOperationsAction
): LabourOperationsState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

const myReducers = {
  serviceGroups: serviceGroupReducer,
  services: servicesReducer,
  rates: rateReducer,
  declinedReasons: declinedReasonsReducer,
  labourOperationsReducer
};

export const reducer = combineReducers(myReducers);

export function createReducer(asyncReducers = {}) {
  let allReducers = Object.assign(myReducers, asyncReducers);
  return combineReducers(allReducers);
}

export function appReducer(state: any, action: any) {
  return createReducer()(state, action);
}

export const metaReducers: MetaReducer<
  LabourOperationsState | ServiceGroupsState | ServiceGroupRatesState | ServicesState
>[] = [serviceGroupStateHydration, servicesStateHydration, serviceGroupRateStateHydration];

// eslint-disable-next-line max-len
export function labourOperationsStateHydration(
  reducer: ActionReducer<LabourOperationsState>
): ActionReducer<LabourOperationsState> {
  // eslint-disable-next-line max-len
  return function(
    state: LabourOperationsState,
    action: any,
    metaReducer: string = 'stateHydration'
  ): LabourOperationsState {
    //console.log('SERVICE GROUPS');
    if (state === undefined) {
      // console.log('populate labour ops from local storage?');
      // let serviceGroups: any = localStorage.getItem('labour-operations-state');
      // state = serviceGroups ? JSON.parse(serviceGroups) : labourOperationsInitialState;
      state = labourOperationsInitialState;
    }
    const newState = reducer(state, action);
    // if (action.feature === 'labourOperations' && action.triggerStorageSync) {
    //   localStorage.setItem('labour-operations-state', JSON.stringify(newState));
    // }

    return newState;
  };
}

export const metaReducers2: MetaReducer<LabourOperationsState>[] = [labourOperationsStateHydration];
